import { useNavigate } from "react-router-dom"
import { Button } from "../../../../../../components/Button/Button"
import useAuth from "../../../../../../hooks/useAuth"
import { i18n } from "../../../../../../translate/i18n"
import { Dropdown } from 'react-bootstrap'
import Swal from "sweetalert2"
import { useState } from "react"

export function OptionsProduct({ hasIntegration, showWrapperModal, hasProduct, deleteAllProduct, }:
    { hasIntegration: boolean, showWrapperModal: (title: string) => void, hasProduct: boolean, deleteAllProduct: () => Promise<void> }) {
    const navigate = useNavigate()
    const { loginInfo } = useAuth()
    const [confirmText, setConfirmText] = useState('')

    return (
        <div className='card-toolbar'>
            {!hasIntegration && (
                <Button
                    text={i18n.t(`buttons.register_product`)}
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-plus'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                        type: 'button',
                    }}
                    click={() => {
                        navigate(
                            loginInfo.plugintype === 'varejo'
                                ? '/product_varejo/criar'
                                : '/product_fashion/criar'
                        )
                    }}
                    btnClass='mb-5 fw-bolder'
                />
            )}
            {!hasIntegration && (
                <Dropdown
                    className='btn btn-primary btn-sm fw-bolder me-5 p-0 mb-5'
                    style={{ marginLeft: '1em' }}
                >
                    <Dropdown.Toggle variant='default' size='sm'>
                        <i className='bi bi-three-dots fs-4 p-0'></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='p-0'>
                        <Dropdown.Item
                            onClick={() => {
                                showWrapperModal('Importar planilha')
                            }}
                            className='p-0 d-flex flex-row justify-content-center'
                        >
                            <div
                                className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                                style={{ color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%' }}
                            >
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='16'
                                    height='16'
                                    fill='currentColor'
                                    className='bi bi-filetype-csv'
                                    viewBox='0 0 16 16'
                                    style={{ color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em' }}
                                >
                                    <path
                                        fill-rule='evenodd'
                                        d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z'
                                    />
                                </svg>
                                <p style={{ color: '#6993FF', fontSize: '1rem' }} className='m-0'>
                                    Importar planilha
                                </p>
                            </div>
                        </Dropdown.Item>

                        {hasProduct && (
                            <>
                                <Dropdown.Divider />
                                <Dropdown.Item
                                    onClick={() => {
                                        Swal.fire({
                                            icon: 'warning',
                                            title: `Atenção!`,
                                            html: `
                              Cuidado ao realizar a exclusão, os dados não poderão ser <b>restaurados!<b/>
                              <div style="margin-top: 8">Digite <b>excluir</b> para confirmar!</div>`,
                                            showCloseButton: true,
                                            showConfirmButton: true,
                                            confirmButtonColor: '#dc3741',
                                            confirmButtonText: 'Excluir',
                                            showCancelButton: false,
                                            input: 'text',
                                            inputPlaceholder: 'excluir',
                                            preConfirm: (text) => {
                                                setConfirmText(text)
                                            },
                                        }).then(async (res) => {
                                            if (res.isConfirmed && res.value && res.value === 'excluir') {
                                                await deleteAllProduct()
                                            } else {
                                                Swal.close()
                                            }
                                        })
                                    }}
                                    className='p-0 d-flex flex-row justify-content-center'
                                >
                                    <div
                                        className='btn m-4 d-flex flex-row justify-content-center align-items-center'
                                        style={{ color: '#F64E60', backgroundColor: '#FFE2E5', width: '90%' }}
                                    >
                                        <i
                                            className='bi bi-x'
                                            style={{ color: '#F64E60', fontSize: '1.5rem', marginRight: '0.5em' }}
                                        ></i>
                                        <p style={{ color: '#F64E60', fontSize: '1rem' }} className='m-0'>
                                            Excluir tudo
                                        </p>
                                    </div>
                                </Dropdown.Item>
                            </>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </div>
    )
}